// extracted by mini-css-extract-plugin
export default {"dropdownBox":"style_dropdownBox__9-j2+","box":"style_box__QbaTM","active":"style_active__nTqB8","title":"style_title__qL0yU","item":"style_item__3nr1u"};